import { ApiClient } from "@topline/services/apiService";
import { AgGridService } from "@topline/services/agGridService";
import { angularServicesNames } from "@topline/services/angularServicesNames";

((module) => {
    module.component('productOwnerAssignments', {
        template: require('./productOwnerAssignmentsComponent.html'),
        bindings: {
            reloadCallback: '=',
            changeProductAssignment: '=',
            removeProductAssignment: '=',
            onOwnerClick: '&',
            canEdit: '<',
            budgetVersion: '<'
        },
        controller: ['$scope', ApiClient.componentName, angularServicesNames.$translate, AgGridService.componentName, ProductOwnerAssignmentsComponent]
    });


    function ProductOwnerAssignmentsComponent(
        this: $TSFixMe,
        $scope: $TSFixMe,
        apiClient: ApiClient,
        $translate: ng.translate.ITranslateService,
        agGridService: AgGridService
    ) {

        const $ctrl = this;

        $ctrl.$onInit = () => {
            $ctrl.initGrid();
            $scope.$watch('$ctrl.budgetVersion', () => loadDataToGrid());
        };
        $scope.$on('LanguageChanged', () => agGridService.refreshGridLanguage($ctrl.gridApi));

        $ctrl.initGrid = () => {
            $ctrl.gridOptions = {
                columnDefs: [{
                        headerName: $translate.instant('PRODUCT_OWNERS.GRID.NAME'),
                        field: "owner",
                        rowGroup: true
                    },
                    {
                        field: 'sku',
                        headerName: $translate.instant('PRODUCT_OWNERS.GRID.SKU.NAME')
                    },
                    {
                        field: 'brand',
                        headerName: $translate.instant('PRODUCT_OWNERS.GRID.SKU.BRAND_NAME')
                    },
                    {
                        field: 'productCode',
                        headerName: $translate.instant('PRODUCT_OWNERS.GRID.SKU.ORACLE_INDEX')
                    },
                    {
                        field: 'country',
                        headerName: $translate.instant('PRODUCT_OWNERS.GRID.SKU.COUNTRY')
                    },
                    {
                        headerName: $translate.instant('PRODUCT_OWNERS.GRID.ACCEPTANT'),
                        field: 'approver'
                    },
                    {
                        headerName: $translate.instant('PRODUCT_OWNERS.GRID.BUSINESS_UNIT_MANAGER'),
                        field: 'businessUnitManager'
                    },
                    {
                        headerName: $translate.instant('PRODUCT_OWNERS.GRID.DIRECTOR'),
                        field: 'director'
                    }
                ],
                animateRows: true,
                defaultColDef: {
                    sortable: true,
                    resizable: true,
                    enableRowGroup: true,
                    filter: "agSetColumnFilter"
                },
                popupParent: document.getElementById('grid-productOwnerAssignments'),
                floatingFilter: true,
                rowGroupPanelShow: 'always',
                suppressContextMenu: true,
                angularCompileRows: true,
                getRowHeight: function (params: $TSFixMe) {
                    if (params.node && params.node.detail) {
                        const offset = 80;
                        const allDetailRowHeight = params.data.assignedProducts.length * 28;
                        return allDetailRowHeight + offset;
                    } else {
                        // otherwise return fixed master row height
                        return 30;
                    }
                },
                pagination: true,
                paginationPageSize: 10,
                domLayout: 'autoHeight',
                localeTextFunc: agGridService.transalteFunc,
                suppressHorizontalScroll: true,
                suppressDragLeaveHidesColumns: true,
                onGridReady: (config: $TSFixMe) => {
                    $ctrl.gridApi = config.api;
                    loadDataToGrid();
                    config.api.sizeColumnsToFit();
                },
                onGridSizeChanged: (config: $TSFixMe) => {
                    config.api.sizeColumnsToFit();
                }
            };
        }

        function loadDataToGrid() {
            if ($ctrl.budgetVersion && $ctrl.gridApi) {
                $ctrl.gridApi.showLoadingOverlay();
                apiClient.getOwnerWithProduct($ctrl.budgetVersion.versionId).then((items: $TSFixMe) => {
                    $ctrl.gridApi.setRowData(items);
                });
            }
        }

    }

})(angular.module('topline.modules'));